var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 7.49996L15.0042 16.955C14.9363 17.3411 14.7346 17.691 14.4343 17.9431C14.1341 18.1951 13.7545 18.3333 13.3625 18.3333H6.6375C6.24545 18.3333 5.86594 18.1951 5.56569 17.9431C5.26543 17.691 5.06366 17.3411 4.99583 16.955L3.33333 7.49996M17.5 4.99996H12.8125M12.8125 4.99996V3.33329C12.8125 2.89127 12.6369 2.46734 12.3243 2.15478C12.0118 1.84222 11.5879 1.66663 11.1458 1.66663H8.85417C8.41214 1.66663 7.98822 1.84222 7.67566 2.15478C7.36309 2.46734 7.1875 2.89127 7.1875 3.33329V4.99996M12.8125 4.99996H7.1875M2.5 4.99996H7.1875",
    stroke: "#9B51E0",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBin);
export default __webpack_public_path__ + "static/media/Bin.fd93d83850a60ba505cc70e55d5d71ad.svg";
export { ForwardRef as ReactComponent };